export default {
  ...(JSON.parse(process.env.GATSBY_IOHK_STARTER_CONFIG))
}
